import { Component, ElementRef, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Highcharts from 'highcharts/highstock';
import Swal from 'sweetalert2'
import HC_exporting from 'highcharts/modules/exporting';
import { Router } from '@angular/router';
import { YieldReportService } from 'src/app/services/yield-report.service';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import OfflineOption from 'highcharts/modules/offline-exporting';

HC_exporting(Highcharts);
OfflineOption(Highcharts);
NoDataToDisplay(Highcharts);
declare var $: any;
@Component({
  selector: 'smart-yield-report',
  templateUrl: './yield-report.component.html',
  styleUrls: ['./yield-report.component.scss']
})
export class YieldReportComponent implements OnInit {
  role: string = ''
  org_id: string = ''
  child_org_id: string = ''
  mobile: boolean = false
  show_chart: boolean = false
  checkall: boolean = false
  @ViewChild('getHeight', { read: ElementRef, static: true }) elementView: ElementRef;
  @ViewChild('HeightCover', { read: ElementRef, static: true }) HeightCover: ElementRef;


  contentHeight: number = 0


  // CHART-------------------------------
  highcharts: typeof Highcharts = Highcharts;
  chartOptionsLeft: any = []
  chartOptionsRight: any = []
  // CHART-------------------------------
  // DATE-FILTER------------------------------
  filter_monthyear_start_show: any = ''
  last_select_month: any = ''
  filter_monthyear_start: any = ''
  @ViewChild('myDivstart') myDivstart: ElementRef;
  @ViewChild('myDivend') myDivend: ElementRef;
  yearselect_start = ''
  before_data_month_start: any
  filter_monthyear_end: any = ''
  filter_monthyear_end_show: any = ''
  before_data_month_end: any
  rollback_css = 'col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center'
  active_css = 'col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center activeselect'
  format_month_year = []
  filter_date: any = []
  array_farm: any = []
  farm_ids: any = []
  group_farm_ids: any = []
  breed_type_ids: any = []
  // DATE-FILTER------------------------------
  data: any = []
  categorie_data: any = []
  categorie_data_2: any = []
  series_data: any = []
  series_data_2: any = []
  data_dropdown: any[]
  chart: any = []
  chart_right: any = []
  list_box: any = []
  old_length = 0
  array_color = [
    "hsla(133,70%,75%,1)",
    "hsla(273,70%,75%,1)",
    "hsla(350,70%,75%,1)",
    "hsla(196,70%,75%,1)",
    "hsla(301,70%,75%,1)",
    "hsla(63,70%,75%,1)",
    "hsla(343,70%,75%,1)",
    "hsla(140,70%,75%,1)",
    "hsla(280,70%,75%,1)",
    "hsla(266,70%,75%,1)",
    "hsla(252,70%,75%,1)",
    "hsla(21,70%,75%,1)",
    "hsla(294,70%,75%,1)",
    "hsla(14,70%,75%,1)",
    "hsla(28,70%,75%,1)",
    "hsla(175,70%,75%,1)",
    "hsla(308,70%,75%,1)",
    "hsla(0,70%,75%,1)",
    "hsla(98,70%,75%,1)",
    "hsla(231,70%,75%,1)",
    "hsla(336,70%,75%,1)",
    "hsla(245,70%,75%,1)",
    "hsla(322,70%,75%,1)",
    "hsla(77,70%,75%,1)",
    "hsla(56,70%,75%,1)",
    "hsla(259,70%,75%,1)",
    "hsla(217,70%,75%,1)",
    "hsla(49,70%,75%,1)",
    "hsla(91,70%,75%,1)",
    "hsla(203,70%,75%,1)",
    "hsla(189,70%,75%,1)",
    "hsla(70,70%,75%,1)",
    "hsla(84,70%,75%,1)",
    "hsla(42,70%,75%,1)",
    "hsla(35,70%,75%,1)",
    "hsla(315,70%,75%,1)",
    "hsla(147,70%,75%,1)",
    "hsla(119,70%,75%,1)",
    "hsla(224,70%,75%,1)",
    "hsla(7,70%,75%,1)",
    "hsla(126,70%,75%,1)",
    "hsla(210,70%,75%,1)",
    "hsla(161,70%,75%,1)",
    "hsla(182,70%,75%,1)",
    "hsla(329,70%,75%,1)",
    "hsla(154,70%,75%,1)",
    "hsla(105,70%,75%,1)",
    "hsla(168,70%,75%,1)",
    "hsla(238,70%,75%,1)",
    "hsla(287,70%,75%,1)",
    "hsla(112,70%,75%,1)"
]

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private _renderer: Renderer2,
    private YieldReportService: YieldReportService,
  ) {
    this.role = sessionStorage.getItem("role")
    this.org_id = sessionStorage.getItem("Org")
    this.child_org_id = sessionStorage.getItem("ChildOrg")

    this.spinner.show()
    this.setHightBetweenChart()
    this.checkWidth()
    this.getDropdown()

  }

  ngOnInit(): void {
     
  }
  getDropdown() {
    let body = {}
    this.YieldReportService.getBreedTypeByFarm(body).subscribe(
      async result => {
        if (result.code == 200) {
          this.data_dropdown = result.data
          this.data_dropdown.map((item, index) => {
            item.fullname = item.farm_name + '/' + item.breed_type_name
            if (index <= 3) {
              item.checkbox = true
              this.array_farm.push(item.fullname)
              this.group_farm_ids.push(item.farm_id)
              this.breed_type_ids.push(item.breed_type_id)
            } else {
              item.checkbox = false
            }
          })
          // //duplicate-value----------------------------
          // this.farm_ids = []
          // this.group_farm_ids.map(item => {
          //   if (this.farm_ids.indexOf(item) == -1) {
          //     this.farm_ids.push(item)
          //   }
          // })
          // //duplicate-value----------------------------
          this.createFilter()
        } else {
          this.callErrorMSG()
        }
      }
    )
  }
  getDataList() {
    this.spinner.show()
    let body = {
      "org_id": this.org_id,
      "child_org_id": this.child_org_id,
      "startDate": this.filter_date[0],
      "endDate": this.filter_date[this.filter_date.length - 1]
    }
    this.YieldReportService.getReportYieldList(body).subscribe(
      async result => {
        if (result.code == 200) {
          this.list_box = result.data
          this.setMissData(this.list_box)
          this.list_box.map(item => {
            let date = new Date(item.update_date)
            item.update_date = date.getUTCDate() + ' ' + this.format_month_eng(date.getUTCMonth() + 1) + ' ' + date.getFullYear() + ' ' + (date.getHours()) + ':' + date.getMinutes()
            item.yields.map(item2=>{
        
                if(item2.no == 1 && this.checkEmpty(item2.value)){
                  item.sum_all_data = parseFloat(item2.value.toFixed(2)) 
                }else if(item2.no == 1 && !this.checkEmpty(item2.value)){
                  item.sum_all_data = 0
                }
                if(item2.no == 2 && this.checkEmpty(item2.value)){
                  item.sum_good_data = parseFloat(item2.value.toFixed(2))
                }else if(item2.no == 2 && !this.checkEmpty(item2.value)){
                  item.sum_good_data = 0
                }
                if(item2.no == 3 && this.checkEmpty(item2.value)){
                  item.sum_fail_data = parseFloat(item2.value.toFixed(2))
                }else if(item2.no == 3 && !this.checkEmpty(item2.value)){
                  item.sum_fail_data = 0
                }
              
            })
          

          })
          this.spinner.hide()
        } else {
          this.callErrorMSG()
        }
      }
    )
  }
  getDataLeftChart() {
    let body = {
      "org_id": this.org_id,
      "child_org_id": this.child_org_id,
      "startDate": this.filter_date[0],
      "endDate": this.filter_date[this.filter_date.length - 1]
    }
    this.YieldReportService.getReportYieldBreed(body).subscribe(
      async result => {
        if (result.code == 200) {
          this.categorie_data = []
          this.series_data = []
          let breed_type_name = []
          this.chart = result.data.chart
          this.setMissData(this.chart)
          if (this.chart.length != 0) {
            this.chart.map(item => {
              if (this.categorie_data.indexOf(item.year) == -1) {
                this.categorie_data.push(item.year)
              }
              if (breed_type_name.indexOf(item.breed_type_name) == -1) {
                breed_type_name.push(item.breed_type_name)
              }
            })
            breed_type_name.map((item,index) => {
              let data = []
              this.categorie_data.map((item2, index) => {
                data.push(0)
                this.chart.map(item3 => {
                  if (item2 == item3.year) {
                    if (item3.breed_type_name == item) {
                      item3.yields.map(item4=>{
                        if(item4.no == 1 && this.checkEmpty(item4.value) ){
                          data[index] = (parseFloat(item4.value.toFixed(2)))
                        }
                      })
                    }
                  }
                })
              })
              this.series_data.push({
                name: item,
                color:this.array_color[index] == undefined?  '': this.array_color[index],
                data: data,
                events: { legendItemClick: function () { return false; } }
              })
            })
            this.old_length = this.series_data.length
          } else {
            this.chartLeftClear()
          }
          this.ChartLeft('column', '', '', 'จำนวน')
          this.getDataRightChart()
        } else {
          this.callErrorMSG()
        }
      }
    )

  }

  getDataRightChart() {
    this.spinner.show()
    let body = {
      "org_id": this.org_id,
      "child_org_id": this.child_org_id,
      "startDate": this.filter_date[0],
      "endDate": this.filter_date[this.filter_date.length - 1],
      "farm_ids": this.group_farm_ids,
      "breed_type_ids": this.breed_type_ids,
    }
    this.YieldReportService.getReportYieldFarm(body).subscribe(
      async result => {
        if (result.code == 200) {
          this.chart_right = result.data.chart
          this.categorie_data_2 = []
          this.series_data_2 = []
          let sum_good_data = []
          let sum_fail_data = []

         this.setMissData(this.chart_right)
          this.chart_right.map((item,index) => {
            sum_good_data.push(0)
            sum_fail_data.push(0)
            this.categorie_data_2.push(item.farm_name + '/' + item.breed_type_name)
            item.yields.map(item2=>{
              
              if(item2.no == 2 && this.checkEmpty(item2.value)){
                sum_good_data[index]=(parseFloat(item2.value.toFixed(2)))
              }

              if(item2.no == 3 && this.checkEmpty(item2.value)){
                sum_fail_data[index]=(parseFloat(item2.value.toFixed(2)))
              }
              

            })
          })




          this.series_data_2 = [
            {
              name: 'ผลดี',
              data: sum_good_data,
              color: '#d9ec93',
              events: { legendItemClick: function () { return false; } }
            },
            {
              name: 'ผลเสีย',
              data: sum_fail_data,
              color: '#f69bb2',
              events: { legendItemClick: function () { return false; } }
            }
          ]
          this.show_chart = true
          this.ChartRight('column', '', '', 'เปอร์เซ็นต์')
          this.setHightBetweenChart()
          this.spinner.hide()

        } else {
          this.spinner.hide()
        }
      }
    )
  }

  MoreDetail(farm_id: any, breed_type_id: any) {
    // this.router.navigate(['/yield-report-sub']);
    var farmid = JSON.stringify(farm_id)
    var breedtypeid = JSON.stringify(breed_type_id)
    this.router.navigate(['/yield-report-sub'], { queryParams: { farm_id: farmid, breed_type_id: breedtypeid } });
  }



  //--SUB-FUNCTION------------------------------------------------------------------------------------------------------------------------
  SelectCheckBox(data: any, farm_id: any, breed_type_id: any, checkall: any) {
    if (!checkall) {
      this.data_dropdown.map(item => {
        if (item.fullname == data) {
          item.checkbox = true
        }
      })
      if (this.array_farm.indexOf(data) == -1) {
        this.array_farm.push(data)
        this.group_farm_ids.push(farm_id)
        this.breed_type_ids.push(breed_type_id)
      } else {
        this.array_farm.splice(this.array_farm.indexOf(data), 1)
        this.group_farm_ids.splice(this.group_farm_ids.indexOf(farm_id), 1)
        this.breed_type_ids.splice(this.breed_type_ids.indexOf(breed_type_id), 1)
      }

    } else {
      this.array_farm = []
      this.group_farm_ids = []
      this.breed_type_ids = []
      if (this.checkall == false) {
        this.checkall = true
        this.data_dropdown.map(item => {
          item.checkbox = true
          if (this.array_farm.indexOf(item.fullname) == -1) {
            this.array_farm.push(item.fullname)
            this.group_farm_ids.push(item.farm_id)
            this.breed_type_ids.push(item.breed_type_id)
          } else {
            this.array_farm.splice(this.array_farm.indexOf(item.fullname), 1)
            this.group_farm_ids.splice(this.group_farm_ids.indexOf(item.farm_id), 1)
            this.breed_type_ids.splice(this.breed_type_ids.indexOf(item.breed_type_id), 1)
          }
        })

      } else {
        this.checkall = false
        this.data_dropdown.map(item => {
          item.checkbox = false
        })
      }
    }
    //checkall---------------------------------------
    if (this.data_dropdown.length == this.breed_type_ids.length) {
      this.checkall = true
    } else {
      this.checkall = false
    }
    //checkall---------------------------------------

    // //duplicate-value----------------------------
    // this.farm_ids = []
    // this.group_farm_ids.map(item => {
    //   if (this.farm_ids.indexOf(item) == -1) {
    //     this.farm_ids.push(item)
    //   }
    // })
    // // duplicate-value----------------------------
    this.getDataRightChart()
    if (this.group_farm_ids.length == 0) {
      this.categorie_data_2 = []
      this.chartRightClear()
      this.ChartRight('column', '', '', 'เปอร์เซ็นต์')
    }
    setTimeout(() => {
      this.contentHeight = this.elementView.nativeElement.offsetHeight;
      this._renderer.setStyle(this.HeightCover.nativeElement, 'height', this.contentHeight + 'px');
    }, 100)
  }
  CancelSelect(data: any) {
    this.array_farm.splice(this.array_farm.indexOf(data), 1)
    this.data_dropdown.map(item => {
      if (item.fullname == data) {
        item.checkbox = false
        this.group_farm_ids.splice(this.group_farm_ids.indexOf(item.farm_id), 1)
        this.breed_type_ids.splice(this.breed_type_ids.indexOf(item.breed_type_id), 1)
      }
    })
    //checkall---------------------------------------
    if (this.data_dropdown.length == this.breed_type_ids.length) {
      this.checkall = true
    } else {
      this.checkall = false
    }
    //checkall---------------------------------------
    // //duplicate-value----------------------------
    // this.farm_ids = []
    // this.group_farm_ids.map(item => {
    //   if (this.farm_ids.indexOf(item) == -1) {
    //     this.farm_ids.push(item)
    //   }
    // })
    // //duplicate-value----------------------------
    this.getDataRightChart()
    if (this.group_farm_ids.length == 0) {
      this.categorie_data_2 = []
      this.chartRightClear()
      this.ChartRight('column', '', '', 'เปอร์เซ็นต์')
    }
    setTimeout(() => {
      this.contentHeight = this.elementView.nativeElement.offsetHeight;
      this._renderer.setStyle(this.HeightCover.nativeElement, 'height', this.contentHeight + 'px');
    }, 100)
  }
  Selectmonth(year, number, month, disable, type, select_month: HTMLElement) {
    this.last_select_month = select_month
    if (disable == false && type == 'start') {
      this.filter_monthyear_start_show = month + '-' + year
      this.filter_monthyear_start = number + '/1/' + year
      this.myDivstart.nativeElement.className = 'dropdown-menu'
      this.yearselect_start = year
      this.format_filterdate()
      if (this.before_data_month_start) {
        if (this.before_data_month_start.textContent != month) {
          this.before_data_month_start.className = this.rollback_css
          select_month.className = this.active_css
          this.before_data_month_start = select_month
        }
      } else {
        this.before_data_month_start = select_month
        select_month.className = this.active_css
      }
    } else if (disable == false && type == 'end') {
      this.filter_monthyear_end_show = month + '-' + year
      this.filter_monthyear_end = number + '/1/' + year
      this.myDivend.nativeElement.className = 'dropdown-menu'
      this.format_filterdate()
      if (this.before_data_month_end) {
        if (this.before_data_month_end.textContent != month) {
          this.before_data_month_end.className = this.rollback_css
          select_month.className = this.active_css
          this.before_data_month_end = select_month
        }
      } else {
        this.before_data_month_end = select_month
        select_month.className = this.active_css
      }
    }

  }
  async createFilter() {
    let today = new Date();
    let format_array = []
    let year_array = []
    let month_array = []
    let year_now = today.getFullYear()
    let month_now = today.getMonth() + 1
    let limit_year = 2
    let limit_month = limit_year * 12
    let chek_month_limit = false
    format_array.push(month_now)
    for (let i = 1; i <= limit_month; i++) {
      let num = Math.abs(month_now - i)
      if (num == 13) {
        chek_month_limit = true
      }
      if (num != 0) {
        format_array.push(num)
      }
    }
    var p1 = format_array.slice(0, month_now);
    p1 = p1.reverse();
    var p2 = format_array.slice(month_now, (12 + month_now));
    var p3: any

    for (let i = 0; i < 12; i++) {
      if (p1[i] != undefined && p1[i] != '' && p1[i] != null) {
        p1[i] = {
          number: p1[i],
          month: this.format_month_eng(p1[i]),
          disable: false
        }
      } else {
        p1[i] = {
          number: i + 1,
          month: this.format_month_eng(i + 1),
          disable: true
        }
      }
      if (p2[i] != undefined && p2[i] != '' && p2[i] != null) {
        p2[i] = {
          number: p2[i],
          month: this.format_month_eng(p2[i]),
          disable: false
        }
      } else {
        p2[i] = {
          number: i + 1,
          month: this.format_month_eng(i + 1),
          disable: true
        }
      }
    }
    month_array.push(p1, p2)
    if (chek_month_limit) {
      p3 = format_array.slice((12 + month_now), limit_month);
      for (let i = 0; i < p3.length; i++) {
        p3[i] = parseInt(p3[i]) - p3.length
      }
      let minus = (p3.length - 1)
      for (let i = 0; i < 12; i++) {
        if (p3[i] == undefined || p3[i] == '' || p3[i] == null) {
          p3[i] = {
            number: i - minus,
            month: this.format_month_eng(i - minus),
            disable: true
          }
        } else {
          p3[i] = {
            number: p3[i],
            month: this.format_month_eng(p3[i]),
            disable: false
          }
        }
      }
      p3.sort(function (a, b) {
        return a.number - b.number;
      });
      month_array.push(p3)
    }

    month_array.reverse()
    for (let i = month_array.length; i >= 1; i--) {
      year_array.push((year_now + 1) - i)
    }
    await Promise.all(year_array.map((item, index) => {
      year_array[index] = {
        year: item,
        month: month_array[index]
      }
    }))
    this.format_month_year = year_array
    let start_month_number = ''
    let start_month = ''
    let end_month_number = ''
    let end_month = ''
    let last_index = this.format_month_year.length - 1
    for (let i = 0; i < this.format_month_year[0].month.length; i++) {
      if (this.format_month_year[0].month[i].disable == false) {
        start_month_number = this.format_month_year[0].month[i].number
        start_month = this.format_month_year[0].month[i].month
        break;
      }
    }
    for (let i = this.format_month_year[last_index].month.length - 1; i >= 0; i--) {
      if (this.format_month_year[last_index].month[i].disable == false) {
        end_month_number = this.format_month_year[last_index].month[i].number
        end_month = this.format_month_year[last_index].month[i].month
        break;
      }
    }
    this.filter_monthyear_start_show = start_month + '-' + this.format_month_year[0].year
    this.filter_monthyear_start = start_month_number + '/1/' + this.format_month_year[0].year
    this.filter_monthyear_end_show = end_month + '-' + this.format_month_year[last_index].year
    this.filter_monthyear_end = end_month_number + '/1/' + this.format_month_year[last_index].year
    this.format_filterdate()


  }
  clear_filetr_date() {
    this.filter_monthyear_start = ''
    this.filter_monthyear_end = ''
    this.filter_monthyear_start_show = ''
    this.filter_monthyear_end_show = ''
    this.createFilter()
  }
  format_filterdate() {
    if (
      (this.filter_monthyear_start != null && this.filter_monthyear_start != '' && this.filter_monthyear_start != undefined) &&
      (this.filter_monthyear_end != null && this.filter_monthyear_end != '' && this.filter_monthyear_end != undefined) &&
      (new Date(this.filter_monthyear_start) > new Date(this.filter_monthyear_end))) {
      Swal.fire({
        icon: 'warning',
        title: 'วันที่ไม่ถูกต้อง',
        showConfirmButton: false,
        timer: 3000
      })
      this.clear_filetr_date()

    } else if ((this.filter_monthyear_start != null && this.filter_monthyear_start != '' && this.filter_monthyear_start != undefined) &&
      (this.filter_monthyear_end != null && this.filter_monthyear_end != '' && this.filter_monthyear_end != undefined)) {
      this.filter_date = []
      let d1 = new Date(this.filter_monthyear_start)
      let d2 = new Date(this.filter_monthyear_end)
      var months;
      let cap = 0
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();

      cap = months <= 0 ? 0 : months
      var month: any = 0
      var limit_month = 12
      var year = d1.getFullYear()
      for (let i = 0; i <= cap; i++) {
        month = d1.getMonth() + 1 + i <= 9 ? '0' + (d1.getMonth() + 1 + i) : (d1.getMonth() + 1 + i)

        if (month > limit_month) {
          month = month - limit_month <= 9 ? '0' + (month - limit_month) : month - limit_month
        }
        if (month > 12) {
          month = month - 12 <= 9 ? '0' + (month - 12) : month - 12
          limit_month += 12
        }
        if (parseInt(month) == 1) {
          year += 1
        }
        this.filter_date.push(year + '-' + month)
      }
      let check_first = this.filter_date[0].split('-')
      if (this.filter_date.length <= 12) {
        if (parseInt(check_first[1]) == 1) {
          this.filter_date.map((item, index) => {
            let split = item.split('-')
            this.filter_date[index] = this.yearselect_start + '-' + split[1]
          })
        }
      } else {
        if (parseInt(check_first[1]) == 1 && this.filter_date.length > 12) {
          this.filter_date.map((item, index) => {
            let split = item.split('-')
            this.filter_date[index] = (parseInt(split[0]) - 1) + '-' + split[1]
          })
        }
      }
      this.getDataLeftChart()
      this.getDataList()
    }

  }
  format_month_eng(data) {
    // data.map(obj=>{
    switch (data) {
      case 1:
        data = 'Jan.'
        break;
      case 2:
        data = 'Feb.'
        break;
      case 3:
        data = 'Mar.'
        break;
      case 4:
        data = 'Apr.'
        break;
      case 5:
        data = 'May'
        break;
      case 6:
        data = 'Jun.'
        break;
      case 7:
        data = 'Jul.'
        break;
      case 8:
        data = 'Aug.'
        break;
      case 9:
        data = 'Sep.'
        break;
      case 10:
        data = 'Oct.'
        break;
      case 11:
        data = 'Nov.'
        break;
      case 12:
        data = 'Dec.'
        break;
    }
    // })
    return data
  }
  checkWidth() {
    if (window.innerWidth <= 1460) {
      this.mobile = true
    } else {
      this.mobile = false
    }

  }
  onResize(event: any) {
    let width = event.target.innerWidth
    if (width <= 1460) {
      this.mobile = true
    } else this.mobile = false
    setTimeout(() => {
      this.contentHeight = this.elementView.nativeElement.offsetHeight;
      this._renderer.setStyle(this.HeightCover.nativeElement, 'height', this.contentHeight + 'px');
    }, 100)

  }
  setHightBetweenChart() {
    setTimeout(() => {
      this.contentHeight = this.elementView.nativeElement.offsetHeight;
      this._renderer.setStyle(this.HeightCover.nativeElement, 'height', this.contentHeight + 'px');
    }, 100)
  }
  ChartLeft(type: string, Title: string, xTitle: string, yTitle: string) {
    let time_now = new Date()
    let image_name = 'กราฟแสดงผลภาพรวมผลผลิต-' + (time_now.getDate() < 10 ? ('0' + time_now.getDate()) : time_now.getDate()) + '-' + ((time_now.getMonth() + 1) < 10 ? ('0' + (time_now.getMonth() + 1)) : (time_now.getMonth() + 1)) + '-' + time_now.getFullYear() + '[' + (time_now.getHours() < 10 ? ('0' + time_now.getHours()) : time_now.getHours()) + '-' + (time_now.getMinutes() < 10 ? ('0' + time_now.getMinutes()) : time_now.getMinutes()) + "]";
    let menuItems = [];
    if(this.role == 'admin' || this.role == 'farm_manager'){
      menuItems = [
        'downloadJPEG', 'downloadPNG', 'viewFullscreen'
      ]
    }else{
      menuItems = [
        'viewFullscreen'
      ]
    }

    Highcharts.setOptions({
      lang: {
        thousandsSep: ',',
        noData: 'ไม่พบข้อมูล'
      }
    });
    this.chartOptionsLeft = {
      exporting: {
        fallbackToExportServer: false,
        enabled: true,
        filename: image_name,
        buttons: {
          contextButton: {
            menuItems: menuItems
          },
        }
      },
      chart: {
        type: type,
        style: {
          fontFamily: 'Kanit',
        }, events: {
          beforePrint: function () {
            this.setSize(1000, null, false)
          },
          afterPrint: function () {
            this.setSize(null, null, false)
          }
        }
      },
      legend: {
        align: 'left',
        verticalAlign: 'top',
        itemMarginLeft: 10,
        itemMarginBottom: 10,
      },
      title: {
        text: Title,
        style: {
          fontSize: '15px',
          fontWeight: 'bold'
        },
        align: 'left',
      },
      xAxis: {
        title: {
          text: xTitle
        },
        categories: this.categorie_data,
        crosshair: true,

      },
      yAxis: {
        min: 0,
        title: {
          text: yTitle
        },
      },
      tooltip: {
        headerFormat: '<span >{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b> {point.y} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.1,
          borderWidth: 0
        }
      },

      series: this.series_data
    };

  }
  ChartRight(type: string, Title: string, xTitle: string, yTitle: string) {
    let time_now = new Date()
    let image_name = 'กราฟเปรียบเทียบผลผลิต-' + (time_now.getDate() < 10 ? ('0' + time_now.getDate()) : time_now.getDate()) + '-' + ((time_now.getMonth() + 1) < 10 ? ('0' + (time_now.getMonth() + 1)) : (time_now.getMonth() + 1)) + '-' + time_now.getFullYear() + '[' + (time_now.getHours() < 10 ? ('0' + time_now.getHours()) : time_now.getHours()) + '-' + (time_now.getMinutes() < 10 ? ('0' + time_now.getMinutes()) : time_now.getMinutes()) + "]";
    let menuItems = [];
    if(this.role == 'admin' || this.role == 'farm_manager'){
      menuItems = [
        'downloadJPEG', 'downloadPNG', 'viewFullscreen'
      ]
    }else{
      menuItems = [
        'viewFullscreen'
      ]
    }
    Highcharts.setOptions({
      lang: {
        thousandsSep: ',',
        noData: 'ไม่พบข้อมูล'
      }
    });
    this.chartOptionsRight = {
      exporting: {
        fallbackToExportServer: false,
        enabled: true,
        filename: image_name,
        buttons: {
          contextButton: {
            menuItems: menuItems
          },
        }
      },
      chart: {
        type: type,
        style: {
          fontFamily: 'Kanit',
        }, events: {
          beforePrint: function () {
            this.setSize(1000, null, false)
          },
          afterPrint: function () {
            this.setSize(null, null, false)
          }
        }
      },
      legend: {
        align: 'left',
        verticalAlign: 'top',
        itemMarginLeft: 10,
        itemMarginBottom: 10,

      },
      title: {
        text: Title,
        style: {
          fontSize: '15px',
          fontWeight: 'bold'
        },
        align: 'left',
      },
      xAxis: {
        title: {
          text: xTitle
        },
        categories: this.categorie_data_2,
        crosshair: true,
      },
      yAxis: {

        min: 0,
        title: {
          text: yTitle
        },
      },
      rangeSelector: {
        allButtonsEnabled: true,
        selected: 1
      },
      tooltip: {
        headerFormat: '<span >{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name} : </td>' +
            '<td style="padding:0;padding-left:5px"><b>{point.y} ( {point.percentage:.2f}% )</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.1,
          borderWidth: 0,
          stacking: 'percent',
          states: {
            inactive: {
              enabled: false
            }
          }
        }

      },

      series: this.series_data_2
    };



  }
  callErrorMSG() {
    Swal.fire({
      icon: 'error',
      title: 'เกิดข้อผิดพลาดในการเรียกข้อมูล',
      showConfirmButton: false,
      timer: 3000
    })
    this.spinner.hide()
  }
  chartRightClear() {
    this.series_data_2 = [
      {
        name: '',
        data: [],
        color: '#d9ec93',
        events: { legendItemClick: function () { return false; } }
      },
      {
        name: '',
        data: [],
        color: '#f69bb2',
        events: { legendItemClick: function () { return false; } }
      }
    ]
  }
  chartLeftClear() {
    this.series_data = []
    for (let i = 0; i < this.old_length; i++) {
      this.series_data.push({
        name: '',
        data: [],
        events: { legendItemClick: function () { return false; } }
      })
    }
  }
  checkEmpty(data){
    if(data !=0 && data != null && data != '' && data != undefined && typeof data != 'string'){
      return true
    }else{
      return false
    }
  }
  setMissData(array){
    array.map((item) => {
      let index_all = item.yields.findIndex(x => x.no == 1 );
      let index_good = item.yields.findIndex(x => x.no == 2 );
      let index_fail = item.yields.findIndex(x => x.no == 3 );
      item.yields.map(item2=>{
        if(!this.checkEmpty(item2.value)){
          if(item2.no == 1){ // ค่า all ไม่มี
            if(this.checkEmpty(item.yields[index_good].value) && this.checkEmpty(item.yields[index_fail].value)){ // แต่มีค่า good และ fail
              item2.value = parseFloat(item.yields[index_good].value) + parseFloat(item.yields[index_fail].value)
            }else if(!this.checkEmpty(item.yields[index_good].value) && this.checkEmpty(item.yields[index_fail].value)){ //ไม่มีค่า good แต่มี fail
              item2.value = parseFloat(item.yields[index_fail].value)
            }else if(this.checkEmpty(item.yields[index_good].value) && !this.checkEmpty(item.yields[index_fail].value)){ //มีค่า good แต่ไม่มี fail
              item2.value = parseFloat(item.yields[index_good].value)
            }
          }
          if(item2.no == 2){// ค่า good ไม่มี
            if(this.checkEmpty(item.yields[index_all].value) && this.checkEmpty(item.yields[index_fail].value)){ // แต่มีค่า all และ fail
              item2.value = parseFloat(item.yields[index_all].value) - parseFloat(item.yields[index_fail].value)
            }else if(this.checkEmpty(item.yields[index_all].value) && !this.checkEmpty(item.yields[index_fail].value)){ //มีค่า all แต่ไม่มี fail
              item2.value = parseFloat(item.yields[index_all].value)
            }
          }
          if(item2.no == 3){// ค่า fail ไม่มี
            if(this.checkEmpty(item.yields[index_all].value) && this.checkEmpty(item.yields[index_good].value)){ // แต่มีค่า all และ good
              item2.value = parseFloat(item.yields[index_all].value) - parseFloat(item.yields[index_good].value)
            }
          }

        }
      })
    })
  }








}
